import * as React from 'react'

import { KitBuilder as KitBuilderProps } from '@thg-commerce/enterprise-network/src/generated/graphql'
import { KitBuilder } from '@thg-commerce/enterprise-widget-kit-builder'

import { BaseWidgetProps } from '../types'

type KitBuilderWidgetRendererProps = BaseWidgetProps &
  Omit<KitBuilderProps, 'query'>

export const KitBuilderWidgetRenderer = (
  props: KitBuilderWidgetRendererProps,
) => {
  return (
    <KitBuilder
      kitBuilderDistributorId={props.kitBuilderDistributorId || ''}
      kitBuilderKey={props.kitBuilderKey || ''}
    />
  )
}
